// extracted by mini-css-extract-plugin
export var bloc = "youtube-module--bloc--e0a8b";
export var contentBackground = "youtube-module--contentBackground--83c3d";
export var h2 = "youtube-module--h2--2cf10";
export var h3Title = "youtube-module--h3Title--90f22";
export var innerBloc = "youtube-module--innerBloc--42bc1";
export var overlay = "youtube-module--overlay--efb41";
export var root = "youtube-module--root--76dfc";
export var textWithBackground = "youtube-module--textWithBackground--73c28";
export var thumbnail = "youtube-module--thumbnail--7c163";
export var title = "youtube-module--title--effee";
export var videoBackground = "youtube-module--videoBackground--54647";
export var videoLight = "youtube-module--videoLight--3d18c";
export var wrapper = "youtube-module--wrapper--f6eaa";
export var writing = "youtube-module--writing--f5ebd";
export var youtube = "youtube-module--youtube--d5e2d";
export var youtubePlayer = "youtube-module--youtubePlayer--aae34";